import 'slick-carousel';

const handleSliderAccessories = () => {
	const $slider = $('.js-slider-accessories');

	$slider.each(function(index, el) {
		const $this = $(this);
		const $slides = $this.find('.slider__slides');

		$slides.slick({
		  infinite: true,
		  slidesToShow: 4,
		  slidesToScroll: 1,
		  dots: false,
		  arrows: true,
		  autoplay: false,
		  adaptiveHeight: true,
		  prevArrow: $this.find('.js-slider-arrow-prev'),
		  nextArrow: $this.find('.js-slider-arrow-next'),
		  responsive: [
		    {
		      breakpoint: 1023,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1
		      }
		    }
		  ]
		});
	});
};

handleSliderAccessories();
